module.exports = __webpack_public_path__ + "img/003B8C8D-EDCF-4B95-A7C7-E357F2E3ABFA-crop.39dfcfdd.png";